import { Component } from '@angular/core';

@Component({
  selector: 'app-policy-header',
  standalone: true,
  imports: [],
  templateUrl: './policy-header.component.html',
  styleUrl: './policy-header.component.scss'
})
export class PolicyHeaderComponent {

}
